import React from 'react';
import {MinusIcon} from "./icons/MinusIcon";
import {PlusIcon} from "./icons/PlusIcon";

class FundingProsAndCons extends React.Component {
  render() {
    return (
      <div className="proscons-wrapper">
        <div className="proscons proscons--pros">
          <ul>
            {this.props.benefits.map((item, index) =>
              <li key={"proscons-pros-"+index}><PlusIcon color="clover" marginToTop={5} /> <span>{item}</span></li>
            )}
          </ul>
        </div>
        <div className="proscons proscons--cons">
          <ul>
            {this.props.disadvantages.map((item, index) =>
              <li key={"proscons-cons-"+index}><MinusIcon color="clover" marginToTop={5}/> <span>{item}</span></li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

export default FundingProsAndCons;
